























import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import {
  Order,
  OrderStatus
} from '@/interfaces/order.interface';
import {namespace} from 'vuex-class';
import {User} from '@/interfaces/user.interface';
import StatusConfirmation from "@/components/StatusConfirmation.vue";

const ordersModule = namespace('orders');
const usersModule = namespace('users');

@Component({
  components: {StatusConfirmation}
})
export default class OrderStatusField extends Vue {
  @ordersModule.State statuses!: OrderStatus[];
  @ordersModule.Action update!: any;
  @usersModule.Getter currentUser!: User;

  @Prop() order!: Order;

  orderStatus: OrderStatus = {};
  isConfirmationModalVisible: boolean = false;

  get filteredStatuses(): OrderStatus[] {
    let filteredStatuses;
    if (this.currentUser.roleName === 'admin_a') {
      filteredStatuses = this.statuses;
    } else {
      filteredStatuses = this.statuses.map(s => {
        return s.name === 'Pending' ? {...s, ...{disabled: true}} : s;
      });
    }
    return filteredStatuses.sort((a, b) => a.rank && b.rank && a.rank > b.rank ? 1 : -1)
  }

  get confirmationRequired(): boolean {
    return this.orderStatus.name === 'Cancelled';
  }

  maybeAskForConfirmation() {
    if (this.confirmationRequired) this.isConfirmationModalVisible = true;
    else this.updateStatus();
  }

  confirmStatusChange(confirmed: boolean) {
    if (confirmed) this.updateStatus();
    else this.setInitialOrderStatus();
    this.isConfirmationModalVisible = false;
  }

  updateStatus() {
    const order: Order = {
      ...this.order,
      ...{
        status: this.orderStatus
      }
    };
    this.update({order});
  }

  get isStatusEditDisabled() {
    if (this.currentUser.roleName) {
      return ['admin_a', 'admin_b', 'admin_c'].indexOf(this.currentUser.roleName) === -1
          && this.orderStatus.name === 'Pending';
    }
    return false;
  }

  setInitialOrderStatus() {
    this.orderStatus = Object.assign({}, this.order.status);
  }

  mounted() {
    this.setInitialOrderStatus();
  }
}
